module.exports = __webpack_public_path__ + "static/media/img_feature_photo2@2x.9d513cc1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SP/@2x/img_feature_photo2@2x.jpg
// module id = 798
// module chunks = 0